import React, { Component, PropTypes } from 'react';
import InterceptedLink from 'react-intercepted-link';
import qs from 'query-string';

import { connect } from 'react-redux';

import { forceTrackingRequest } from 'job-tracking';
import { trackedLinkClicked } from 'store/location/location';

// Matches a single leading slash or a fully qualified SEEK domain:
const seekDomainRegex = /^\/(?!\/)|seek\.(com\.au|co\.nz)/i;

const combineIntercepts = (intercept, onLinkClick, analytics, href) => {
  const intercepts = [intercept, forceTrackingRequest];

  if (analytics) {
    intercepts.push(() => onLinkClick({ analytics, href }));
  }

  return intercepts;
};

const mapDispatchToProps = dispatch => ({
  onLinkClick: link => dispatch(trackedLinkClicked(link))
});

@connect(null, mapDispatchToProps)
export default class ExternalLink extends Component {

  static propTypes = {
    href: (props, propName, componentName) => {
      const propValue = props[propName];

      if (typeof propValue === 'undefined') {
        return new Error(`Required prop \`${propName}\` was not specified in \`${componentName}\`.`);
      }

      if (typeof propValue !== 'string') {
        return new Error(`Invalid prop \`${propName}\` of type \`${typeof propValue}\` supplied to \`${componentName}\`, expected \`string\`.`);
      }

      if (!/^(http|\/)/.test(propValue)) {
        return new Error(`Invalid prop \`${propName}\` supplied to \`${componentName}\`, expected '/${propValue}' to start with 'http' or '/'.`);
      }

      return null;
    },
    query: PropTypes.object,
    intercept: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    onLinkClick: PropTypes.func,
    analytics: PropTypes.string,
    target: PropTypes.string
  };

  static defaultProps = {
    query: {},
    target: ''
  };

  constructor(props) {
    super(props);

    this.getTarget = this.getTarget.bind(this);
  }

  getTarget(href) {
    return this.props.target || (seekDomainRegex.test(href) ? '_self' : '_target');
  }

  getSeekUrl(href) {
    // Convert to NZ here
    return href;
  }

  getPath(href) {
    return seekDomainRegex.test(href) ? this.getSeekUrl(href) : href;
  }

  getQueryString(query) {
    return Object.keys(query).length > 0 ?
      `?${qs.stringify(query)}` :
      '';
  }

  render() {
    const { href, children, query, onLinkClick, analytics, intercept, ...props } = this.props;
    const combinedIntercepts = combineIntercepts(intercept, onLinkClick, analytics, href);

    return (
      <InterceptedLink {...props} intercept={combinedIntercepts} target={this.getTarget(href)} href={`${this.getPath(href)}${this.getQueryString(query)}`}>
        {children}
      </InterceptedLink>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/ExternalLink/ExternalLink.js
 **/